/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import { Form, MaskedInput } from 'rsuite';
import { FormFieldSize } from 'components/Form/CustomForm/CustomForm';
import FormControlLabel from 'components/Form/Control/FormControlLabel';
// eslint-disable-next-line import/no-unresolved
import styles from './PhoneNumberFormField.module.scss';

const config = {
  name: 'US phone number',
  mask: [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  placeholder: '(555) 495-3947',
};

const PhoneNumberFormField = forwardRef((props: any, ref: any) => {
  const { size, name, helpMessage, label, required, className } = props;

  return (
    <Form.Group
      ref={ref}
      className={[
        styles.formGroup,
        (size as FormFieldSize) === 'sm' ? styles.sm : styles.lg,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <FormControlLabel required={required || false}>
        {label}{' '}
      </FormControlLabel>
      <div className={styles.controlWrapper}>
        <Form.Control
          name={name}
          accepter={MaskedInput}
          mask={config.mask}
          guide
          keepCharPositions
          type="tel"
        />
        {helpMessage ? <Form.HelpText>{helpMessage}</Form.HelpText> : null}
      </div>
    </Form.Group>
  );
});

export default PhoneNumberFormField;
